import { createRouter, createWebHistory } from 'vue-router'

import Apps from '../templates/apps.vue'
import Login from '../templates/login.vue'
import LoginAs from '../templates/login_as.vue'
import SignUp from '../templates/signup.vue'
import LoginSignUp from '../templates/login-signup.vue'
import ForgotPass from '../templates/forgot_pass.vue'
import ResetPass from '../templates/reset_pass.vue'
import ForgotEmail from '../templates/forgot_email.vue'
import ResetEmail from '../templates/reset_email.vue'

import ResendActivate from '../templates/resend_activate.vue'
import Activate from '../templates/activate.vue'

import OauthMain from '../templates/oauth/main.vue'

/* =========================================================
   Environment detection (HYBRID)
   ========================================================= */

const env = process.env.RAILS_ENV
const hostname = window.location.hostname

const isLocal =
  env === 'development' ||
  hostname.includes('localhost')

const isProd =
  env === 'production' ||
  (hostname.includes('arbitersports.com') && !hostname.includes('beta'))

const isStaging =
  env === 'staging' ||
  hostname.includes('arbitersports-beta.com')

// Enable SSO only for staging + prod
const isArbiterSsoRedirectEnv = !isLocal

console.log('ENV DEBUG →', {
  env,
  hostname,
  isLocal,
  isStaging,
  isProd,
  isArbiterSsoRedirectEnv
})
/* =========================================================
   Entry + Account URLs
   ========================================================= */
const ENTRY_URL = isProd
  ? 'https://www1.arbitersports.com/Shared/Access.aspx'
  : 'https://www1.arbitersports-beta.com/Shared/Access.aspx'

const ACCOUNT_URL = isProd
  ? 'https://account.students.arbitersports.com/'
  : 'https://account.students.arbitersports-beta.com/'

console.log('URL CONFIG →', {
  ENTRY_URL,
  ACCOUNT_URL
})
/* =========================================================
   Arbiter redirect builder
   ========================================================= */
const arbiterEntryUrl = () => {
  let bodyData = {}
  try {
    const raw = document.body?.getAttribute('data') || '{}'
    console.log('BODY RAW DATA →', raw)
    bodyData = JSON.parse(raw)
  } catch (e) {
    console.warn('Failed to parse body data, using fallback', e)
  }
  const base = bodyData.arbitersports_url || ENTRY_URL
  const redirectBackTo = bodyData.account_url || ACCOUNT_URL

  const finalUrl = `${base}?action=signout&RedirectUrl=${encodeURIComponent(redirectBackTo)}`

  console.log('REDIRECT BUILD →', {
    bodyData,
    base,
    redirectBackTo,
    finalUrl
  })

  return finalUrl
}

const routes = [
    {path: '/',       component: Login, meta:{title: 'login', requiresArbiterSso: true }},
    {path: '/login',  component: Login, meta:{title: 'login', requiresArbiterSso: true }},
    {path: '/signup', component: SignUp, meta:{title: 'create_account', requiresArbiterSso: true }},
    {path: '/login-signup', component: LoginSignUp, props:{no_login_footer: true}},
    {path: '/login-as',     component: LoginAs},
    {path: '/signin_as',    component: LoginAs},
    {path: '/apps',   component: Apps},
    {path: '/forgot', component: ForgotPass, meta:{title: 'forgot_pass'}},
    {path: '/reset',  component: ResetPass},
    {path: '/reset/:token',  component: ResetPass},
    {path: '/forgot-email', component: ForgotEmail, meta:{title: 'reset_email'}},
    {path: '/reset-email',  component: ResetEmail},
    {path: '/reset-email/:token',  component: ResetEmail},

    {path: '/resend-activate/:token', component: ResendActivate},
    {path: '/activate/:token',        component: Activate},
    {path: '/oauth/authorize',        component: OauthMain},
]

export const router = createRouter({
    history: createWebHistory(),
    routes
})
/* =========================================================
   SSO Guard (FINAL HYBRID VERSION)
   ========================================================= */
router.beforeEach((to) => {
  console.log('-----------------------------')
  console.log('ROUTE NAVIGATION →', to.path)

  // Skip SSO on local
  if (!isArbiterSsoRedirectEnv) {
    console.log('SSO SKIPPED → Local environment')
    return true
  }

  const requiresSso = to.matched.some(route => route.meta?.requiresArbiterSso)

  console.log('SSO CHECK →', {
    requiresSso,
    matchedRoutes: to.matched.map(r => r.path)
  })

  // Loop prevention ONLY for Arbiter entry domains
  const isOnArbiterEntry =
    hostname.includes('www1.arbitersports') ||
    hostname.includes('go.arbitersports')

  const alreadyRedirected = sessionStorage.getItem('arbiter_sso_done')

  const hasSsoCookie =
    document.cookie.includes('ArbiterB2C=') ||
    document.cookie.includes('ArbiterB2CRef=')

  /* ================= INVITE CAPTURE ================= */
  const referrer = document.referrer

  const isInviteReferrer =
    window.location.hostname.includes('account.students') &&
    referrer &&
    (
      referrer.includes('invitations.students.arbitersports-beta.com') ||
      referrer.includes('invitations.students.arbitersports.com')
    )

  if (
    isInviteReferrer &&
    !sessionStorage.getItem('invite_redirect_url') &&
    !sessionStorage.getItem('invite_redirect_done')
  ) {
    console.log('Saving FULL invite URL →', referrer)
    const inviteUrl = document.referrer
    sessionStorage.setItem('invite_redirect_url', inviteUrl)
  }

  const inviteUrl = sessionStorage.getItem('invite_redirect_url')
  const inviteHandled = sessionStorage.getItem('invite_redirect_done')


  console.log('LOOP CHECK →', {
    hostname,
    isOnArbiterEntry,
    alreadyRedirected,
    hasSsoCookie,
    inviteUrl,
    inviteHandled
  })

   /* ================= INVITE REDIRECT (ONCE) ================= */
  if (
    inviteUrl &&
    !inviteHandled &&
    hasSsoCookie
  ) {
    // remove only URL, keep flag
    sessionStorage.removeItem('invite_redirect_url')
    console.log('Redirecting to invite →', inviteUrl)
    sessionStorage.setItem('invite_redirect_done', 'true')

    window.location.href = inviteUrl
    return false
  }

  /* =========================================================
     CLEANUP stale SSO flag after logout
     ========================================================= */
  if (!hasSsoCookie && alreadyRedirected) {
    console.log('NO COOKIE → clearing stale session flag')
    sessionStorage.removeItem('arbiter_sso_done')
  }


  /* =========================================================
     EXISTING SSO FLOW (UNCHANGED)
     ========================================================= */
  if (requiresSso && !isOnArbiterEntry) {

    // CASE 1: Coming from Arbiter → cookie exists → WAIT
    if (hasSsoCookie && !alreadyRedirected) {
      console.log('SSO COOKIE FOUND → waiting for session API')
      return true
    }

    // CASE 2: Fresh user → redirect to Arbiter
    if (!hasSsoCookie && !alreadyRedirected) {
      const redirectUrl = arbiterEntryUrl()
      console.log('REDIRECTING TO ARBITER →', redirectUrl)
      sessionStorage.setItem('arbiter_sso_done', 'true')
      window.location.href = redirectUrl
      return false
    }

    // CASE 3: Prevent loop
    if (alreadyRedirected) {
      console.log('ALREADY REDIRECTED → allow navigation')
      return true
    }
  }

  console.log('NO REDIRECT → Continue navigation')
  return true
})